import { exportToCSV } from "./exportCsv";

/**
 * Shared "download this list" helpers used across the Placement screens
 * (council, employer, student). Two outputs, no extra dependencies:
 *
 *   - Excel  : reuses exportToCSV (ExcelJS -> real .xlsx).
 *   - PDF    : opens a clean print window with the table and calls print(),
 *              so the user can Save as PDF. No server round-trip, works for
 *              whatever rows the screen already has.
 *
 * `columns` is [{ key, label }]; `rows` is an array of plain objects.
 */

const cell = (row, key) => {
  const v = typeof key === "function" ? key(row) : row[key];
  return v === null || v === undefined ? "" : String(v);
};

export function exportListExcel(columns, rows, fileName) {
  const data = (rows || []).map((r) => {
    const o = {};
    columns.forEach((c) => {
      o[c.label] = cell(r, c.key);
    });
    return o;
  });
  if (!data.length) {
    // ExcelJS needs at least one row to read headers from.
    const empty = {};
    columns.forEach((c) => (empty[c.label] = ""));
    data.push(empty);
  }
  exportToCSV(data, fileName || "export");
}

const escapeHtml = (s) =>
  String(s)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");

export function printListPdf(title, columns, rows) {
  const head = columns.map((c) => `<th>${escapeHtml(c.label)}</th>`).join("");
  const body = (rows || [])
    .map(
      (r) =>
        "<tr>" +
        columns.map((c) => `<td>${escapeHtml(cell(r, c.key))}</td>`).join("") +
        "</tr>"
    )
    .join("");

  const when = new Date().toLocaleString();
  const html = `<!doctype html><html><head><meta charset="utf-8"><title>${escapeHtml(
    title
  )}</title><style>
    body{font-family:Arial,Helvetica,sans-serif;color:#222;padding:18px;}
    h2{color:#16294d;margin:0 0 2px 0;font-size:18px;}
    .sub{color:#777;font-size:11px;margin-bottom:12px;}
    table{width:100%;border-collapse:collapse;font-size:11px;}
    th,td{border:1px solid #cfd6e4;padding:5px 7px;text-align:left;vertical-align:top;}
    th{background:#16294d;color:#fff;}
    tr:nth-child(even) td{background:#f5f7fb;}
    @media print{.noprint{display:none;}}
  </style></head><body>
    <h2>${escapeHtml(title)}</h2>
    <div class="sub">NSVEC Placement &bull; Generated on ${escapeHtml(when)} &bull; ${
    (rows || []).length
  } record(s)</div>
    <table><thead><tr>${head}</tr></thead><tbody>${body ||
    `<tr><td colspan="${columns.length}" style="text-align:center;color:#888;">No records.</td></tr>`}</tbody></table>
    <script>window.onload=function(){window.print();}</script>
  </body></html>`;

  const w = window.open("", "_blank");
  if (!w) {
    alert("Please allow pop-ups to download the PDF.");
    return;
  }
  w.document.open();
  w.document.write(html);
  w.document.close();
}
